import ScanCodeAuthenticatorComponent from "../components/ScanCodeAuthenticatorComponent";
import {useEffect, useState} from "react";
import {IconButton} from "@mui/material";
import AuthenticatorAddedComponent from "../components/AuthenticatorAddedComponent";
import DownloadAuthenticatorComponent from "../components/DownloadAuthenticatorComponent";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EnterCodeAuthenticatorComponent from "../components/EnterCodeAuthenticatorComponent";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "i18nano";
import useFormattingTranslations from "../hooks/useFormattingTranslations";
import {useAuthStore} from "../stores/authStore";
import {ApiService} from "../api/ApiService";
import {useUserStore} from "../stores/userStore";
import {CheckNeedAdditionalAuth} from "../helpers/authHelper";
import {useNotification} from "../stores/notificationStore";
import StackCard from "../components/StackCard";
import WithLogoAndSelectLanguageWrapper from "../components/WithLogoAndSelectLanguageWrapper";

const AuthenticatorPage = () => {
    const userStore = useUserStore();
    const authStore = useAuthStore();
    let [step, setStep] = useState(0);
    const navigate = useNavigate();
    const t = useTranslation();
    const tf = useFormattingTranslations()

    const [sendCodeLoading, setSendCodeLoading] = useState(false);
    const notification = useNotification();

    const sendCode = async (code: string) => {
        setSendCodeLoading(true);
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.TwoFactor(authStore.login, authStore.password, code);
        if (response.success) {
            userStore.login(response.data);
        } else {
            const needText = CheckNeedAdditionalAuth(response);
            if (needText) {
                navigate(needText);
                return;
            }
            if (response.errors[0]) {
                notification.open(response.errors[0], "error");
            } else {
                notification.open(t("Something went wrong"), "error");
            }
        }
        setSendCodeLoading(false);
    }

    useEffect(() => {
        if (!authStore.login || !authStore.password) {
            navigate("/login")
        }
    }, [])

    return (
            <WithLogoAndSelectLanguageWrapper>
                <StackCard>
                    {step !== 0 ?
                            < IconButton aria-label="back" style={{position: "absolute", left: "5px", top: "5px"}}
                                         onClick={() => setStep(step - 1)}>
                                <ArrowBackIcon/>
                            </IconButton>
                            : null
                    }
                    {
                        step === 0 ? <DownloadAuthenticatorComponent onClick={() => setStep(1)}/> :
                                step === 1 ? <ScanCodeAuthenticatorComponent
                                                authenticatorUri={authStore.response?.data.authenticatorUri}
                                                sharedKey={authStore.response?.data.sharedKey}
                                                onClick={() => setStep(2)}/> :
                                        step === 2 ? <EnterCodeAuthenticatorComponent
                                                        onClick={sendCode}
                                                        loading={sendCodeLoading}
                                                        title={"Enter Code"}
                                                        description={
                                                            <span>{tf("Once you have scanned the QR code")}</span>}
                                                /> :
                                                step === 3 ? <AuthenticatorAddedComponent
                                                        onClick={() => navigate("/login")}/> : null
                    }
                </StackCard>
            </WithLogoAndSelectLanguageWrapper>
    );
}

export default AuthenticatorPage